import React, { useEffect, useState } from "react"
import Navbar from "../../components/navbar/Navbar"

import { CategorySlider } from "../../components/categorySlider"
import { graphql } from "gatsby"
import { getFooterConfigObject, getMenuConfigObject } from "../../utils/graphqlUtils"
import TemplateWrapper from "../../components/layout"

import Swiper from "swiper"
import "./index.scss"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import { Footer } from "../../components/footer/Footer"
import { FiltersModal } from "../../components/filtersModal"
import { AppButton } from "../../components/button"
import filter from "../../images/filter-icon.png"
import { connect } from "react-redux"
import { CLEAR_FILTERS } from "../../state/constants"
import { RichText } from "prismic-reactjs"
import { deburr } from "lodash"
import * as _ from "lodash"

import ArrowDown from "../../images/angle-double-down-solid.svg"
import ArrowUp from "../../images/angle-double-up-solid.svg"

export const OurChocolate = connect(state => state.app)(({ data, ...props }) => {

  // console.log("cat props", props, "productFilters", props.productFilters)

  const isDesktop = useMediaQuery("(min-width:600px)")

  const [switchLayout, setSwitchLayout] = useState(false)

  const [open, setOpen] = useState(false)

  const [noResults, setNoResults] = useState(false)

  const getRealData = () => {
    return (data &&
      data.prismic &&
      data.prismic.allOur_chocolate_pages &&
      data.prismic.allOur_chocolate_pages.edges[0] &&
      data.prismic.allOur_chocolate_pages.edges[0].node &&
      data.prismic.allOur_chocolate_pages.edges[0].node.product_categories
      && data.prismic.allOur_chocolate_pages.edges[0].node.product_categories.filter(({ category }) => category && category.products && !category.disabled))
  }

  const getStaticData = () => {
    return (data &&
      data.prismic &&
      data.prismic.allOur_chocolate_pages &&
      data.prismic.allOur_chocolate_pages.edges[0] &&
      data.prismic.allOur_chocolate_pages.edges[0].node)
  }

  const getCategories = () => {
    return (data &&
      data.prismic &&
      data.prismic.allProduct_categorys &&
      data.prismic.allProduct_categorys.edges)
  }

  const [realData, setRealData] = useState(getRealData())
  const [visibleCategories, setVisibleCategories] = useState(getRealData())

  const [allIngredients, setAllIngredients] = useState([])

  const [scrollUp, setScrollUp] = useState(false)
  const [scrollDown, setScrollDown] = useState(true)

  useEffect(() => {
    if (!isDesktop) {
      if (typeof document !== "undefined") {
        if (document.documentElement.scrollTop === 0) {
          setScrollUp(false)
          setScrollDown(true)
        }
        let lastScrollTop = 200
        document.onscroll = () => {
          let st = document.pageYOffset || document.documentElement.scrollTop
          if (st > lastScrollTop) {
            setScrollUp(false)
            setScrollDown(true)
          } else {
            setScrollDown(false)
            setScrollUp(true)
          }
          lastScrollTop = st <= 0 ? 0 : st // For Mobile or negative scrolling
        }
      }
    }
  }, [])

  // const scrollToTop = () => {
  //   if (typeof document !== "undefined") {
  //     document.body.scrollTop = 0;
  //     document.documentElement.scrollTop = 0;
  //   }
  //   if (document.documentElement.scrollTop === 0) {
  //     setScrollUp(false)
  //     setScrollDown(true)
  //   }
  //   console.log('scrolltop', document.documentElement.scrollTop)
  // }
  //
  // const scrollToBottom = () => {
  //   if (typeof document !== "undefined") {
  //     document.body.scrollTo(0, document.body.scrollHeight)
  //     document.documentElement.scrollTo(0, document.body.scrollHeight)
  //   }
  // }

  useEffect(() => {
    // populate all ingredients
    let ingr = []
    const filtered = getCategories().filter((cat) => !cat.node.disabled && cat.node.products && cat.node.products.filter(pr => pr.product))
    filtered.map((cat) => {
      cat.node.products.filter(prod => prod.product && prod.product.ingredients).forEach((prod => {
        prod.product.ingredients && prod.product.ingredients.forEach((ing) => {
          if (ing.ingredient) {
            if (ingr.indexOf(ing.ingredient.name) === -1) {
              ingr.push(ing.ingredient.name)
              ingr.sort()
            }
          }
        })
      }))
    })
    setAllIngredients(ingr)
    // console.log("allIngredients: ", ingr)
  }, [])

  const ingredientsContains = (ingredients, search) => {
    if (!ingredients) return false
    for (let i of ingredients) {
      if (i.ingredient && _.deburr(i.ingredient.name.toLowerCase()).includes(search)) {
        return true
      }
    }
    return false
  }

  const typesContains = (types, search) => {
    if (!types) return false
    for (let t of types) {
      if (t.chocolate_type && _.deburr(t.chocolate_type.name.toLowerCase()).includes(search)) {
        return true
      }
    }
    return false
  }

  useEffect(() => {
    let catsWithIngr = getCategories()
    let { ingredients, shapes, types, search } = props.productFilters
    if ((!ingredients || ingredients.length === 0)
      && (!shapes || shapes.length === 0)
      && (!types || types.length === 0)
      && (!search || search.length === 0)) {
      //console.log("visibleCategories no filters ", realData.length)
      setVisibleCategories([...realData])
      return
    }

    let filteredCats = []
    //console.log("visibleCategories filters ingr", ingr, realData, catsWithIngr)
    realData.forEach(c => {
      let filteredProducts = []

      if (c.category && c.category.products) {
        let catWithIngr = catsWithIngr.find(ci => ci.node.name === c.category.name)
        //console.log("filtering " + c.category.name, "catWithIngr: ", catWithIngr)
        c.category.products.forEach(p => {
          let productWithIngr = catWithIngr.node.products.find(pi => p && p.product && pi.product && pi.product.name && pi.product.name === p.product.name)
          //console.log("filtering " + c.category.name, "productWithIngr: ", productWithIngr)
          if (!productWithIngr) return
          let matchesIngredients = false
          if (!ingredients || ingredients.length === 0) {
            matchesIngredients = true
          } else {
            if (productWithIngr.product.ingredients) {
              productWithIngr.product.ingredients.forEach(i => {
                if (i.ingredient) {
                  for (let searchI of ingredients) {
                    //console.log("matching ingredient", i, "with filtered ingr: ", searchI)
                    if (searchI === i.ingredient.name) {
                      // console.log("matched ingredient", i, "with filtered ingr: ", searchI)
                      matchesIngredients = true
                      break
                    }
                  }
                }
              })
            }
          }
          if (!matchesIngredients) return

          let matchesTypes = false
          if (!types || types.length === 0) {
            matchesTypes = true
          } else {
            if (productWithIngr.product.chocolate_types) {
              productWithIngr.product.chocolate_types.forEach(t => {
                if (t.chocolate_type) {
                  for (let searchT of types) {
                    if (searchT === t.chocolate_type.name) {
                      matchesTypes = true
                      break
                    }
                  }
                }
              })
            }
          }
          if (!matchesTypes) return

          let matchesShapes = false
          if (!shapes || shapes.length === 0) {
            matchesShapes = true
          } else {
            for (let searchS of shapes) {
              if (searchS === productWithIngr.product.chocolate_shape?.name) {
                matchesShapes = true
                break
              }
            }
          }
          if (!matchesShapes) return

          let matchesSearch = false
          if (!search || search.length === 0) {
            matchesSearch = true
          } else {
            let searchText = search.toLowerCase().trim()
            matchesSearch =
              (productWithIngr.product.name
                && _.deburr(productWithIngr.product.name.toLowerCase()).includes(searchText))
              || (productWithIngr.product.description
              && productWithIngr.product.description.length > 0
              && productWithIngr.product.description[0].text
              && _.deburr(productWithIngr.product.description[0].text.toLowerCase()).includes(searchText))
              || (ingredientsContains(productWithIngr.product.ingredients, searchText))
              || (productWithIngr.product.chocolate_shape && _.deburr(productWithIngr.product.chocolate_shape.name.toLowerCase()).includes(searchText))
              || (typesContains(productWithIngr.product.chocolate_types, searchText))
          }
          if (!matchesSearch) return

          filteredProducts.push(p)
        })
      }
      if (filteredProducts.length > 0) {
        let cat = { ...c }
        cat.category = { ...cat.category }
        cat.category.products = filteredProducts
        filteredCats.push(cat)
      }
    })
    if (filteredCats.length === 0) {
      setNoResults(true)
      filteredCats = [...realData]
    } else {
      setNoResults(false)
    }

    setVisibleCategories(filteredCats)
  }, [props.productFilters])

  useEffect(() => {
    if (filtersSwiper) filtersSwiper.update()
    if (filtersSwiperMobile) filtersSwiperMobile.update()
    if (verticalSwiper) verticalSwiper.update()
  }, [visibleCategories])

  const [filtersSwiper, setFilterSwiper] = useState(null)
  const [filtersSwiperMobile, setFiltersSwiperMobile] = useState(null)
  const [verticalSwiper, setVerticalSwiper] = useState(null)

  const [product, setProduct] = useState('');

  useEffect(() => {
    if (filtersSwiper) filtersSwiper.destroy()
    if (filtersSwiperMobile) filtersSwiperMobile.destroy()
    setFilterSwiper(new Swiper(`.filters-swiper.swiper-container`, {
      navigation: {
        nextEl: ".swiper-button-next.filters-next",
        prevEl: ".swiper-button-prev.filters-prev"
      },
      slidesPerView: 8,
      spaceBetween: 10,
      touchRatio: 0
    }))

    setFiltersSwiperMobile(new Swiper(`.filters-swiper-mobile.swiper-container`, {
      slidesPerView: 4.5
    }))

    if (isDesktop) {
      let hash = props.location.hash.replace("#", "")
      // console.log('hash1', hash);
      const hashParts = props.location.hash.split('#');

      if (hashParts.length > 2) {
        hash = hashParts.slice(1)[0];
        // console.log('hash2', hash);
        // console.log(hash)
      }
      // console.log(hash)
      //const categories = realData.filter(validateCategory)
      const categories = visibleCategories.filter(validateCategory)
      const found = categories.find(({ category }) => category._meta.uid === hash)
      const indexOf = categories.indexOf(found)

      if (verticalSwiper) verticalSwiper.destroy()
      setVerticalSwiper(new Swiper(".vertical-slider.swiper-container", {
        direction: "vertical",
        slidesPerView: 1,
        initialSlide: indexOf,
        spaceBetween: -1,
        mousewheel: true,
        keyboard: true,
        touchRatio: 0,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet: (index, className) => {
            if (categories && categories.length)
            return `<span class="custom-desktop-category-slider-bullet ${className}"><span>${categories[index]?.category?.name}</span></span>`
            else {
              return ''
            }
          }
        }
      }))
    }
  }, [data, isDesktop, switchLayout, visibleCategories])

  const validateCategory = ({ category }) => {
    return !!(category && !category.disabled && category.products && category.products.filter(pc => pc.product).length)
  }

  const clearFilters = () => {
    setNoResults(false)
    props.dispatch({
      type: CLEAR_FILTERS
    })
  }

  return <TemplateWrapper id="our-chocolate">
    <Navbar {...props} menuObject={getMenuConfigObject(data)} data={data}>
      <div className="container top-filters px-0">
        <div className="product-filters-container disable-scrollbar d-flex d-sm-none">
          <div className="filters-swiper-mobile swiper-container">
            <div className="swiper-wrapper">
              {visibleCategories.filter(validateCategory).map(({ category }, index) => (
                <div className="swiper-slide product-filter" key={index.toString() + "_" + category.products.length}>
                  <a key={index.toString() + "_" + category.products.length} href={`#_${category?._meta?.uid}#${product}`}>
                    <img src={category.filter_image?.url} alt={category.filter_image?.alt}/>
                    <p className="filter-title">{category.name}</p>
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="product-filters-container disable-scrollbar d-none d-sm-flex">
          <div className="filters-swiper swiper-container">
            <div className="swiper-wrapper">
              {visibleCategories.filter(validateCategory).map(({ category }, index) => (
                <div className="swiper-slide product-filter" key={index.toString() + "_" + category.products.length}>
                  <div key={index.toString() + "_" + category.products.length} className="product-filter" onClick={() => verticalSwiper && verticalSwiper.slideTo(index)}>
                    <img src={category.filter_image?.url} alt={category.filter_image?.alt}/>
                    <p className="filter-title">{category.name}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="swiper-button-prev filters-prev"/>
          <div className="swiper-button-next filters-next"/>
        </div>
      </div>
    </Navbar>

    <div className="container-fluid px-0 sliders-container" style={{ paddingTop: isDesktop ? "0" : props.cookies.visible && !isDesktop ? "282px" : "200px" }}>
      {/*<div className="d-none d-sm-block" style={{ height: 50 }}/>*/}
      <div className={isDesktop ? "vertical-slider swiper-container" : "position-relative pt-4"}>
        {!isDesktop && scrollDown && <div className="arrow-container"><img className="img-fluid scroll-arrow" src={ArrowDown} width="15"/></div>}
        {!isDesktop && scrollUp && <div className="arrow-container"><img className="img-fluid scroll-arrow" src={ArrowUp} width="15"/></div>}
        {noResults &&
        <div
          className="no-results-container mt-5 mb-3 px-3 m-sm-0">{getStaticData().no_search_results_text && getStaticData().no_search_results_text[0] && RichText.render(getStaticData().no_search_results_text)}</div>
        }
        <div className="switch d-flex d-sm-none">
          <div className={switchLayout ? "swipe" : "swipe active-border"} onClick={() => setSwitchLayout(false)}/>
          <div className="grid" onClick={() => setSwitchLayout(true)}>
            <div>
              <div className={switchLayout ? "grid-square active-border" : "grid-square"}/>
              <div className={switchLayout ? "grid-square active-border" : "grid-square"}/>
            </div>
            <div>
              <div className={switchLayout ? "grid-square active-border" : "grid-square"}/>
              <div className={switchLayout ? "grid-square active-border" : "grid-square"}/>
            </div>
          </div>
        </div>
        <div className={isDesktop ? "swiper-wrapper" : ""}>
          {/*{console.log(realData.filter(validateCategory))}*/}
          {visibleCategories.filter(validateCategory).map((categoryNode, index) =>
            !categoryNode.category.disabled && categoryNode.category.products &&
            <div key={index.toString() + "_" + categoryNode.category.products.length}
                 className={isDesktop ? "swiper-slide text-center position-relative" : "position-relative"}>
              <div className="container text-center d-none logo-name">
                <img className="img-fluid my-3 d-inline-block" src={categoryNode.category?.logo_image?.url} width="60"/>
                <div className="vertical-slider-category-name mb-3 d-none d-sm-block">{categoryNode.category.name}</div>
              </div>
              <div className="container d-block d-sm-none text-center mt-4">
                <div className="decorator-img ">
                  <img className="img-fluid" src={categoryNode.category?.logo_image?.url} width="75"/>
                </div>
              </div>
              <CategorySlider
                {...props}
                switchLayout={switchLayout}
                category={categoryNode.category}/>
              {(props.productFilters.ingredients.length > 0
                || props.productFilters.shapes.length > 0
                || props.productFilters.types.length > 0
                || props.productFilters.search.length > 0) &&
              <div className="clear-filters p-3" onClick={() => clearFilters()}>
                {getStaticData().clear_filters_button_text}
              </div>
              }
              <div className="filter-button" onClick={(e) => {
                setOpen(true)
              }}>
                <AppButton style={{
                  backgroundColor: (props.productFilters.ingredients.length > 0 || props.productFilters.shapes.length > 0
                    || props.productFilters.types.length > 0
                    || props.productFilters.search.length > 0) ? "#59bc48" : "#fbcda9"
                }} pageContext={props.pageContext}>
                  <img src={filter} alt="" height="20px"/>
                </AppButton>
              </div>
            </div>
          )}
        </div>
        <div className="swiper-pagination d-none d-sm-block"/>
      </div>
    </div>
    <div className="d-block d-sm-none">
      <Footer data={getFooterConfigObject(data)}/>
    </div>
    <FiltersModal {...props} data={data} allIngredients={allIngredients} open={open} dispatch={props.dispatch} onClose={() => {
      setOpen(false)
    }}/>
  </TemplateWrapper>
})


export default OurChocolate

export const pageQuery = graphql`
    query OurChocolateQuery($lang: String) {
        prismic {
            allOur_chocolate_pages(lang: $lang)  {
                edges {
                    node {
                        title
                        no_search_results_text
                        clear_filters_button_text
                        search_field_placeholder
                        search_field_button_text
                        apply_filters_button_text
                        product_categories {
                            category {
                                ... on PRISMIC_Product_category {
                                    disabled
                                    name
                                    filter_image
                                    filter_label
                                    logo_image
                                    products {
                                        product {
                                            ... on PRISMIC_Product {
                                                _meta {
                                                    uid
                                                    lang
                                                }
                                                name
                                                description
                                                related_products_title
                                                background_image
                                                details_button_text
                                                no_aspect_ratio_image
                                                nutrition_values
                                                nutrition_values_pop_up_footer
                                                nutrition_values_pop_up_title
                                                product_image
                                            }
                                        }
                                    }
                                    _meta {
                                        uid
                                        lang
                                    }
                                }
                            }
                        }
                    }
                }
            }
            allChocolate_shapes(lang: $lang) {
                edges {
                    node {
                        name
                        image
                    }
                }
            }
            allChocolate_types(lang: $lang) {
                edges {
                    node {
                        name
                        image
                    }
                }
            }
            allProduct_categorys(lang: $lang) {
                edges {
                    node {
                        _meta {
                            uid
                        }
                        name
                        disabled
                        products {
                            product {
                                ... on PRISMIC_Product {
                                    name
                                    description
                                    ingredients {
                                        ingredient {
                                            ... on PRISMIC_Ingredient {
                                                name
                                            }
                                        }
                                    }
                                    chocolate_types {
                                        chocolate_type {
                                            ... on PRISMIC_Chocolate_type {
                                                name
                                            }
                                        }
                                    }
                                    chocolate_shape {
                                        ... on PRISMIC_Chocolate_shape {
                                            name
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            allMenus(lang: $lang) {
                edges {
                    node {
                        what_makes_heidi_unique_label
                        what_makes_heidi_unique_disabled
                        promo_campaign_label
                        promo_campaign_disabled
                        products_label
                        products_disabled
                        online_shop_label
                        online_shop_disabled
                        contact_disabled
                        chocolate_lover_disabled
                        contact_label
                        chocolate_lover_label
                        chocolate_label
                        chocolate_disabled
                        careers_label
                        careers_disabled
                        shops_page_label
                        shops_page_disabled
                    }
                }
            }
            allFooter_privacy_policy_linkss(lang: $lang) {
                edges {
                    node {
                        footer_privacy_policy_links {
                            link_title
                            link_resource {
                                ... on PRISMIC__FileLink {
                                    _linkType
                                    url
                                }
                            }
                        }
                    }
                }
            }
            allCookie_consents(lang: $lang) {
                edges {
                    node {
                        cookie_consent_text
                        cookie_consent_link {
                            ... on PRISMIC__ExternalLink {
                                url
                            }
                        }
                        cookie_consent_link_text
                        cookie_consent_button_text
                    }
                }
            }
        }
    }

`
